import {
  Callout,
  DirectionalHint,
  Stack,
  Text,
  useTheme,
} from '@fluentui/react';
import React, { useState } from 'react';
import { useStyles } from '../index.styles';
import { ItemRow } from '..';
import { useTravelIcon } from 'travelAuthorization/TravelPlan/view/FormView/Trips/TripModal/FormView/SectionToggle/utils';

type LocatorProps = {
  item: ItemRow;
};

export const Locator: React.FC<LocatorProps> = ({ item }) => {
  const styles = useStyles();
  const tripCount = item.trip?.notesByEntityId?.totalCount ?? 0;
  const tripItemsCount =
    item.trip?.tripItems?.nodes?.reduce(
      (acc, item) => acc + (item?.notesByEntityId?.totalCount ?? 0),
      0
    ) ?? 0;

  const count = tripCount + tripItemsCount;
  const calloutId = `vendorCallout${item.id}`;
  const [visible, setVisible] = useState(false);
  const { getIcon } = useTravelIcon();
  const { palette } = useTheme();
  return (
    <>
      {!!count && (
        <Stack>
          <Stack
            id={calloutId}
            onMouseEnter={() => setVisible(true)}
            onMouseLeave={() => setVisible(false)}
            className={styles.notesCountContainer}
          >
            <Text styles={{ root: { color: palette.white } }}>{count}</Text>
          </Stack>
        </Stack>
      )}
      <>
        {visible && (
          <Callout
            className={styles.callout}
            gapSpace={0}
            target={`#${calloutId}`}
            directionalHint={DirectionalHint.rightBottomEdge}
            setInitialFocus
          >
            <Stack tokens={{ padding: 20 }}>
              <Text variant="xLargePlus">Trip notes</Text>
              <Stack tokens={{ padding: '10px 0px' }}>
                {item.trip?.notesByEntityId.nodes.map(
                  (tripItemNotes, index) => {
                    return (
                      <Stack>
                        <Text>{tripItemNotes.noteComment}</Text>
                      </Stack>
                    );
                  }
                )}
              </Stack>
              <Stack tokens={{ childrenGap: 10, padding: '10px 0px' }}>
                {item.trip?.tripItems.nodes.map((tripItem, index) => {
                  if (!tripItem.notesByEntityId.totalCount) {
                    return;
                  }
                  return (
                    <Stack
                      key={index}
                      className={styles.tripSectionNotesContainer}
                    >
                      <Stack
                        horizontal
                        verticalAlign="center"
                        tokens={{ childrenGap: 10, padding: '10px 5px' }}
                      >
                        <Text variant="mediumPlus">
                          {tripItem?.tripSection?.name}
                        </Text>
                        {getIcon(tripItem?.tripSection?.layoutType || null, 20)}
                      </Stack>
                      <Stack tokens={{ padding: '0px 5px' }}>
                        {tripItem.notesByEntityId.nodes.map(
                          (tripItemNotes, index) => {
                            return (
                              <Stack>
                                <Text>{tripItemNotes.noteComment}</Text>
                              </Stack>
                            );
                          }
                        )}
                      </Stack>
                    </Stack>
                  );
                })}
              </Stack>
            </Stack>
          </Callout>
        )}
      </>
    </>
  );
};
